'use client';

import { CircleCheck, CircleX, LoaderCircle, Square } from 'lucide-react';

import type { JobView } from '../use-conversation';

export function TaskStatus({ job, onCancel, onRetry }: Readonly<{ job: JobView | null; onCancel(): void; onRetry(): void }>): React.ReactElement | null {
  if (!job) return null;
  const isActive = job.state === 'QUEUED' || job.state === 'RUNNING';
  const label = job.state === 'QUEUED' ? '任务已排队' : job.state === 'RUNNING' ? 'AI 正在整理' : job.state === 'SUCCEEDED' ? '单据已生成' : job.state === 'CANCELLED' ? '任务已取消' : '任务失败';
  const failureHint = job.state === 'FAILED' ? taskFailureHint(job.errorCode) : null;
  return (
    <section className="chat-task-status" aria-label="Chat 任务状态">
      <div className="task-status-leading">
        {isActive ? <LoaderCircle className="spin" size={18} /> : job.state === 'SUCCEEDED' ? <CircleCheck size={18} /> : job.state === 'CANCELLED' ? <Square size={18} /> : <CircleX size={18} />}
        <div><strong>{label}</strong><small>{job.kind} · {job.state}</small>{failureHint ? <p role="alert">{failureHint}</p> : null}</div>
      </div>
      <div className="task-status-actions">
        {isActive ? <button className="icon-button" type="button" aria-label="取消任务" title="取消任务" onClick={onCancel}><Square size={15} /></button> : null}
        {job.state === 'FAILED' ? <button className="secondary-button" type="button" onClick={onRetry}>保留原文重试</button> : null}
      </div>
    </section>
  );
}

function taskFailureHint(errorCode: string | null): string | null {
  if (errorCode === 'PROVIDER_OUTPUT_TRUNCATED') return '产品明细较多，AI 结果超出输出长度上限。请将产品拆分为较小订单后重试。';
  if (errorCode === 'PROPOSAL_SOURCE_VALUE_MISMATCH') return '来源引用不完整。请将声明、地址和检验结果按原文逐行提供，保留全部限定语句、标签和联系方式后重试。';
  if (errorCode === 'PROPOSAL_NO_USABLE_FIELDS') return '没有可直接写入草稿的可信字段。请检查字段标签和值是否对应，或先用手工表单建立草稿。';
  return null;
}
